enum BulkActionStatus {
    PENDING = 'pending',
    PROCESSING = 'processing',
    FAILED = 'failed',
    COMPLETED = 'completed',
}

enum BulkActionType {
    DELETE_CONTACTS = 'delete_contacts',
    ARCHIVE_CONTACTS = 'archive_contacts',
    UNARCHIVE_CONTACTS = 'unarchive_contacts',
    ADD_CONTACT_TAGS = 'add_contact_tags',
    REMOVE_CONTACT_TAGS = 'remove_contact_tags',
    MANAGE_CONTACT_ENGAGE_SUBSCRIPTIONS = 'manage_contact_engage_subscriptions',
}

enum BulkActionResource {
    CONTACTS = 'contacts',
}

export { BulkActionStatus, BulkActionType, BulkActionResource };
